import React from 'react';
import Linkify from 'react-linkify';
const TxtMessage = (props) => {
  return <div className="sc-message--text">{
    <Linkify properties={{ target: '_blank' }}>{props.data.text}<br/>{props.data.dthr}</Linkify>
  }</div>
}
export default TxtMessage
